require("./notificationControllerView.scss");

// @ vendor
const PropTypes = require("prop-types");
const React = require("react");
const { connect } = require("react-redux");
const { withRouter } = require("react-router-dom");
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const { PopoverMenu } = require('commonsComponents/popoverMenu');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require("commonsComponents/OKCover");
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

const { CallMeBack } = require("components/callMeBack/callMeBack");
// import { NotificationSettingView }  from 'ok-notification-management'
const { NotificationSettingViewController } = require('ok-notification-management');
const { initNotificationManagement } = require('ok-notification-management');

const ContactInfoBox = require("components/myProfile/contactInfoBox/contactInfoBox");

const infoIcon = require("assets/images/icon-info-blue.svg");

let environmentConfig = require('core/environmentConfig');

// @actions
const { success } = require('actions/notifications');

class NotificationControllerView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            default: null
        };
    }

    buildOptionsMenu = () => {
        let options = [
            {
                link: `/`,
                text: formatText('notificationManagement-languageOption')
            },
            {
                link: `/`,
                text: formatText('notificationManagement-turnOffOption')
            }
        ];

        const targetElement = (
            <div className="transfers-more-options-button">
                <OKButton
                    modifier="ghost"
                    inverse={true}
                    rightIcon="icon-dropdown-abrir"
                    smallRightIcon={true}
                >
                    <FormattedText value="notificationManagement-optionTitle" />
                </OKButton>
            </div>
        );

        const content = (
            <PopoverMenu
                target={targetElement}
                items={options}
                placement="bottomRight"
            />
        );

        return content;
    }

    buildBreadcrumb() {
        const { match: { params } } = this.props;

        return [
            {
                text: formatText('notificationManagement-notificationManagement'),
                url: '/myprofile/notification'
            },
            {
                text: formatText('notificationManagement-settingsNotificationsTitle'),
                url: '/myprofile/notification/management'
            },
            {
                text: formatText(`notificationManagement-${params.idcontroller}`),
                url: ''
            }
        ];
    }

    buildSuccessMessage = () => {
        const { success } = this.props;

        success({message: formatText('notificationManagement-successChanges')})
    }

    render() {
        const { match: { params } } = this.props;

        return (
            <div>
                <div className="container-fluid user-notifications--header-identifier">
                    <div className="row">
                        <OKCover
                            size="small"
                            section="pg"
                            customClass="col-xs-12"
                        >
                            <OKHeaderSubPage
                                breadcrumbConfig={this.buildBreadcrumb()}
                                finalTitle={formatText('notificationManagement-titleCover')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-positive">
                        <div className="row">
                            <div className="col-xs-12 col-md-8">
                                <NotificationSettingViewController
                                    handleControllers={() => this.buildSuccessMessage}
                                    formatText={(id) => <FormattedText value={id} />}
                                    configuration={initNotificationManagement(environmentConfig.baseHost, params.idcontroller)}
                                />
                            </div>
                            <div className="col-xs-12 col-md-4">
                                <div className="row">
                                    <div className="col-xs-6 col-md-12">
                                        <ContactInfoBox
                                            boxTitle={formatText('notificationManagement-titleInfoBox')}
                                            boxBody={formatText('notificationManagement-bodyInfoBox')}
                                            icon={infoIcon}
                                        />
                                    </div>
                                    <div className="col-xs-6 col-md-12 grid-view--fix-cell-separation">
                                        <CallMeBack isSmall={true} pageTitle={formatText('notificationManagement-titleCover')} hasEntrance={false} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

NotificationControllerView.propTypes = {
    match: PropTypes.object.isRequired,
    success: PropTypes.func,
};

module.exports.constructor = NotificationControllerView;
module.exports.NotificationControllerView = connect(() => ({}),{ success })(withRouter(NotificationControllerView));
